module.exports = "<div class=\"view-port\" style=\"\n    overflow: hidden;\n    display: block;\n    height: 100%;\n    width: 100%;\n\">\n    <h3 class=\"module-header\" style=\"margin-top: 1rem; margin-left: 14px;\">\n        <span style=\"margin-left:8px;\">Network Extension</span>\n    </h3>\n    <iframe class=\"embedded-content-view\" name=\"fleet-embed\" src=\"/hybridity/ui/hcx-ui/resources/networks/index.html\"\n        frameborder=\"0\">\n    </iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/network-extension/network-extension-embed.html
// module id = ZJsG
// module chunks = 0